import { isDefined } from '@sgme/fp';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { WorkspaceTabOwnProps } from 'shared/connect/connect';
import { saveCorrelationsInputs } from 'state/quotes/correlations/correlations.action';
import { getCorrelationSaveInfo, hasAtLeastOnCorrelationParam } from 'state/quotes/correlations/correlations.selectors';
import { getFormEnrichedTradeDate, getIsTraderUser, getPricerRfqIdByWorkspaceTab } from 'state/selectors';
import { ThunkDispatch } from 'state/state.common';
import { AppState } from 'state/state.model';
import { QuoteWorkspaceType } from 'state/workspaces/model';

interface StateProps {
  display: boolean;
  enabled: boolean;
}
interface DispatchProps {
  saveClicked: () => void;
}
interface OwnProps extends WorkspaceTabOwnProps<QuoteWorkspaceType> {}
interface Props extends StateProps, DispatchProps, OwnProps {}

const mapStateToProps = (state: AppState, { formId, workspace }: OwnProps): StateProps => {
  const isTrader = getIsTraderUser(state);
  const hasTradeDate = isDefined(getFormEnrichedTradeDate(state, formId));
  const pricerRfqId = getPricerRfqIdByWorkspaceTab(state, workspace, formId);
  const saveInfo = getCorrelationSaveInfo(state, formId);
  return {
    display: isTrader === true && isDefined(pricerRfqId),
    enabled: hasTradeDate && hasAtLeastOnCorrelationParam(state, formId) && saveInfo?.status !== 'loading',
  };
};
const mapDispatchToProps = (dispatch: ThunkDispatch, { formId, workspace }: OwnProps): DispatchProps => {
  return {
    saveClicked() {
      dispatch(saveCorrelationsInputs(formId, workspace));
    },
  };
};
function SaveButton({ display, enabled, saveClicked }: Props) {
  if (!display) {
    return;
  }
  return (
    <button
      className="btn btn-lg btn-flat-primary btn-icon-end align-items-center"
      onClick={saveClicked}
      disabled={!enabled}
    >
      <FormattedMessage id="save" />
      <i className="icon">save</i>
    </button>
  );
}

export const ConnectedSaveButton = connect(mapStateToProps, mapDispatchToProps)(SaveButton);
